module.exports = __webpack_public_path__ + "images/emoji/currency_exchange.6cf3269efd4585718194.png";